module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/ko/4-2932c9282eeb4bf7d0da9e199239abca.jpg";